import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpClientXsrfModule, HttpResponse } from '@angular/common/http';
import { AuthResponseData } from './api.lib';
import { BehaviorSubject, Observable, catchError, of, tap, throwError, from, finalize } from 'rxjs';
import { AppConfig, CONFIG_TOKEN } from '../setup/config';
import { environment } from '../../environments/environment';
import { LoggerService } from '../shared/logger.service';
import { SettingsService } from '../settings/settings.service';
import { refreshTokenEndpoint } from '../common/constants.lib';
import { method } from 'lodash';

const { apiUrl } = environment;

// const { apiUrl } = environment;

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private _csrfToken: BehaviorSubject<string> = new BehaviorSubject<string>('not set');
  get csrfToken$() {
    return this._csrfToken.asObservable();
  }
  get csrfToken() {
    return this._csrfToken.getValue();
  }
  set csrfToken(val: string) {
    this._csrfToken.next(val);
  }

  constructor(
    private logger: LoggerService,
    private http: HttpClient,
    @Inject(CONFIG_TOKEN) private config: AppConfig,
  ) {
    // this.apiUrl = this.settingsService.settings?.apiUrl || 'wallyrules';
  }

  //#region CSRF

  getCsrf() {
    // this.logger.debug('getCsrf:apiUrl: ', apiUrl);
    return this.http.get<any>(encodeURI(`${apiUrl}/csrfToken`), {
      // observe: 'response',
      withCredentials: true
    })
      .pipe(
        tap((resp: any) => {
          // this.logger.debug('getCsrf:tap:resp: ', resp);
          this.csrfToken = resp._csrf;
          // this.headers = new HttpHeaders().set('X-CSRF-TOKEN', this.csrfToken)
          // .set('XSRF-TOKEN', this._csrfToken)
          ;
          // 'Content-Type': 'application/json'
          // this.logger.debug('getCsrf:tap:_csrfToken: ', this._csrfToken);
          // this.logger.debug('getCsrf:tap:header: ', this.headers);
          // this.logger.debug('getCsrf:tap:header: ', this.headers.get('X-CSRF-TOKEN'));
          // this.logger.debug('set-cookie: ', resp.headers);
          // this.logger.debug('getCsrf:tap:header: ', this.headers.get('XSRF-TOKEN'));
          // let wallyHeaders = new HttpHeaders()
          //   .set('wally', this._csrfToken);
          // this.logger.debug('wally: ', wallyHeaders.get('wally'));
        }),
        catchError(errorRes => {
          this.logger.error(`getCsrf:error:`, errorRes.message);
          return throwError(() => errorRes);
        })
      );
    // .subscribe({
    //   next: resData => {
    //     this.logger.debug('getCsrf:resData: ', resData);
    //     // return resolve(true);
    //   },
    //   error: err => {
    //     this.logger.error('getCsrf:error: ', err.message);
    //     // return reject(err);
    //   }
    // });
  }

  getCsrfAsPromise() {
    return new Promise((resolve, reject) => {
      // this.logger.debug('getCsrfAsPromise...');
      return this.getCsrf()
        .subscribe({
          next: resData => resolve(resData),
          error: err => {
            this.logger.error('getCsrfAsPromise:error: ', err.message);
            resolve(null);
          }
        })
    })
  }

  //#endregion

  //#region Generics

  //#region Fetch

  fetchCaller(url: string, options: any = {
    method: 'GET',
    credentials: 'omit'
  }): Promise<any> {
    this.logger.debug(`fetchCaller: `, url, options);
    return fetch(encodeURI(`${apiUrl}/${url}`), options)
      .then(async (resp) => {
        this.logger.debug(`fetchCaller: resp: `, resp);
        const { ok, status, statusText } = resp;
        if (!ok) {
          return Promise.reject(`fetchCaller: Http-Error: ${status}: ${statusText}`);
        }
        return resp;
      })
      .catch(err => {
        this.logger.error(`fetchCaller: `, err);
        return Promise.reject(err);
      })
  }

  blobGet(url: string, calledFrom: string = 'calledFrom') {
    this.logger.debug(`blobGet:`, url);
    return this.getHttpCallAsPromise(url, calledFrom, 'blob')
      .then(resp => {
        const objectUrl = URL.createObjectURL(resp);
        return objectUrl;
      })
      .catch(err => {
        this.logger.error(`blobGet:${calledFrom}: Error: `, err);
        return Promise.reject(`blobGet: getBlob: Unexpected error`);
      });
    // // return this.fetchCaller(url)
    // .then(async (resp) => {
    //   this.logger.debug(`blobGet:resp: `, resp);
    //   return resp;
    //   // let data = await resp.blob();
    //   // if (data) {
    //   //   return data;
    //   // }
    //   // return Promise.reject(`getBlob: Unexpected error`);
    // })
    // .catch(err => {
    //   this.logger.error(`blobGet:${calledFrom}: Error: `, err);
    //   return Promise.reject(`blobGet: getBlob: Unexpected error`);
    // })
  }

  //#endregion

  //#region GET

  getHttpCall(url: string, calledFrom: string = 'calledFrom', responseType: any = 'json') {
    // this.logger.debug(`getHttpCall:<${calledFrom}>
    //   url: ${url} `);
    return this.http
      .get<any>(encodeURI(`${apiUrl}/${url}`), {
        // headers: this.headers,
        responseType: responseType,
        withCredentials: true
      })
      .pipe(
        tap(() => {
          // this.logger.debug('getHttpCall:tap...');
          if (url !== refreshTokenEndpoint) {
            this.getCsrf();
          }
        }),
        catchError(errorRes => {
          this.logger.error(`getHttpCall:${calledFrom}:error: `, errorRes.message);
          return throwError(() => errorRes);
        }),
        finalize(() => {
          // this.logger.debug(`getHttpCall:finalize...`);
        })
      );
  }

  getHttpCallAsPromise(url: string, calledFrom: string = 'calledFrom', responseType: any = 'json'): Promise<any> {
    return new Promise((resolve, reject) => {
      // this.logger.debug('getHttpCallAsPromise: ', url, calledFrom);
      return this.getHttpCall(url, calledFrom, responseType)
        .subscribe({
          next: resData => resolve(resData),
          error: err => reject(err)
        });
    });
  }

  // getHttpCallAsPromise(url: string, calledFrom: string = 'calledFrom'): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this.logger.debug('getHttpCallAsPromise: ', url, calledFrom);
  //     return this.getCsrfAsPromise()
  //       .then(done => {
  //         return this.getHttpCall(url, calledFrom)
  //           .subscribe({
  //             next: resData => resolve(resData),
  //             error: err => reject(err)
  //           });

  //       })
  //       .catch(err => reject(err));
  //   });
  // }

  //#endregion

  //#region POST

  postHttpCall(url: string, body: any | null, calledFrom: string = 'calledFrom', responseType: any = 'json') {
    this.logger.debug(`postHttpCall:<${calledFrom}>
      url: ${url} `, responseType);
    return this.http
      .post<any>(encodeURI(`${apiUrl}/${url}`), body, {
        responseType: responseType,
        withCredentials: true
      })
      .pipe(
        catchError(errorRes => {
          this.logger.error(`postHttpCall:${calledFrom}:error: `, errorRes.message);
          return throwError(() => errorRes);// new Error(errorRes));
        })
      );
  }

  // postHttpCallAsPromise(url: string, body: any | null, calledFrom: string = 'calledFrom'): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     return this.postHttpCall(url, body, calledFrom)
  //       .subscribe({
  //         next: resData => resolve(resData),
  //         error: err => reject(err)
  //       });
  //   });
  // }

  postHttpCallAsPromise(url: string, body: any | null, calledFrom: string = 'calledFrom', responseType: any = 'json'): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.getCsrfAsPromise()
        .then((done: any) => {
          // this.logger.debug(`got csrf: %o`, done);
          // let newBody = { ...done, ...body };
          // this.logger.debug(`newBody: %o`, newBody);
          return this.postHttpCall(url, body, calledFrom, responseType)
            .subscribe({
              next: resData => resolve(resData),
              error: err => reject(err)
            });
        })
        .catch(err => reject(err));
    });
  }

  //#endregion

  //#region PUT

  putHttpCall(url: string, body: any | null, calledFrom: string = 'calledFrom', responseType: any = 'json') {
    // this.logger.debug(`putHttpCall:<${calledFrom}>
    //   url: ${url} `, body);
    return this.http
      .put<any>(encodeURI(`${apiUrl}/${url}`), body, {
        responseType: responseType,
        withCredentials: true
      })
      .pipe(
        catchError(errorRes => {
          this.logger.error(`putHttpCall:${calledFrom}:error: `, errorRes.message);
          return throwError(() => errorRes);
        })
      );
  }

  // putHttpCallAsPromise(url: string, body: any | null, calledFrom: string = 'calledFrom'): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     return this.putHttpCall(url, body, calledFrom)
  //       .subscribe({
  //         next: resData => resolve(resData),
  //         error: err => reject(err)
  //       });
  //   });
  // }

  putHttpCallAsPromise(url: string, body: any | null, calledFrom: string = 'calledFrom', responseType: any = 'json'): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.getCsrfAsPromise()
        .then(done => {
          return this.putHttpCall(url, body, calledFrom, responseType)
            .subscribe({
              next: resData => resolve(resData),
              error: err => reject(err)
            });
        })
        .catch(err => reject(err));
    });
  }

  //#endregion

  //#region DELETE

  deleteHttpCall(url: string, calledFrom: string = 'calledFrom') {
    // this.logger.debug(`getHttpCall:<${calledFrom}>
    //   url: ${url} `);
    return this.http
      .delete<any>(encodeURI(`${apiUrl}/${url}`), {
        withCredentials: true
      })
      .pipe(
        catchError(errorRes => {
          this.logger.error(`getHttpCall:${calledFrom}:error: `, errorRes.message);
          return throwError(() => errorRes);
        })
      );
  }

  // deleteHttpCallAsPromise(url: string, calledFrom: string = 'calledFrom'): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     return this.deleteHttpCall(url, calledFrom)
  //       .subscribe({
  //         next: resData => resolve(resData),
  //         error: err => reject(err)
  //       });
  //   });
  // }

  deleteHttpCallAsPromise(url: string, calledFrom: string = 'calledFrom'): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.getCsrfAsPromise()
        .then(done => {
          return this.deleteHttpCall(url, calledFrom)
            .subscribe({
              next: resData => resolve(resData),
              error: err => reject(err)
            });
        })
        .catch(err => reject(err));
    });
  }

  //#endregion

  //#region REPORT

  getHttpReport(url: string, calledFrom: string = 'calledFrom') {
    this.logger.debug(`getHttpReport:<${calledFrom}>   url: ${url} `);
    return this.http.get<ArrayBuffer>(encodeURI(`${apiUrl}/${url}`), {
      // headers: this.headers,
      responseType: 'arraybuffer' as 'json',
      withCredentials: true
    })
      .pipe(
        tap(() => {
          this.logger.debug('getHttpReport:tap...');
          // this.getCsrf();
        }),
        catchError(errorRes => {
          this.logger.error(`getHttpReport:${calledFrom}:error: `, errorRes.message);
          return throwError(() => errorRes);
        })
      );
  }

  getHttpReportAsPromise(url: string, calledFrom: string = 'calledFrom'): Promise<any> {
    return new Promise((resolve, reject) => {
      this.logger.debug('getHttpReportAsPromise: ', url, calledFrom);
      return this.getHttpReport(url, calledFrom)
        .subscribe({
          next: resData => resolve(resData),
          error: err => reject(err)
        });
    });
  }

  // getHttpReportAsPromise(url: string, calledFrom: string = 'calledFrom'): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     this.logger.debug('getHttpReportAsPromise: ', url, calledFrom);
  //     return this.getCsrfAsPromise()
  //       .then(done => {
  //         return this.getHttpReport(url, calledFrom)
  //           .subscribe({
  //             next: resData => resolve(resData),
  //             error: err => reject(err)
  //           });

  //       })
  //       .catch(err => reject(err));
  //   });
  // }

  //#endregion

  //#endregion

}
